// extracted by mini-css-extract-plugin
export var emptyState = "_5s-d";
export var statCard = "_5s-c";
export var table = "_5s-0";
export var tableCell = "_5s-4";
export var tableCellClickable = "_5s-5 _5s-4";
export var tableCellDefault = "_5s-6 _5s-4";
export var tableCellEmpty = "_5s-8";
export var tableCellWithValue = "_5s-7";
export var tableContainer = "_5s-e";
export var tableHeaderWeight = "_5s-1";
export var tableHeaderZone = "_5s-2";
export var tableRowHeader = "_5s-3";
export var viewModeButton = "_5s-9";
export var viewModeButtonActive = "_5s-a _5s-9";
export var viewModeButtonInactive = "_5s-b _5s-9";